import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text as ChakraText,
  useToast,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Req } from 'use-http'
import { colors } from '../../../ui-kit'

interface Props {
  url: string | null
  urlId: string | null
  clientNumber?: string
  isOpen: boolean
  request: Req
  onClose(): void
  refreshPerformanceItems(): void
}

const DeleteUrlModal = (props: Props): React.ReactElement => {
  const {
    url,
    urlId,
    clientNumber,
    isOpen,
    onClose,
    request,
    refreshPerformanceItems,
  } = props
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false)
  const { t } = useTranslation()
  const toast = useToast()

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete URL</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ChakraText display="inline" color={colors.appDarkIndigo}>
            {t('url', 'URL')}
          </ChakraText>
          {url && (
            <ChakraText
              display="inline"
              color={colors.appSlate}
              fontWeight="semibold"
            >
              {` ${url} `}
            </ChakraText>
          )}
          <ChakraText display="inline" color={colors.appDarkIndigo}>
            {t(
              'will_be_permanently_deleted',
              'will be permanently deleted. Click on Submit to proceed with the operation.',
            )}
          </ChakraText>
        </ModalBody>
        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button
            onClick={onClose}
            variant="outline"
            isDisabled={isDeleteDisabled}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="deleteCTA"
            isDisabled={isDeleteDisabled}
            onClick={async () => {
              setIsDeleteDisabled(true)
              if (clientNumber) {
                await request.delete(
                  `/api/performance/${clientNumber}/url/${urlId}`,
                )
                if (!request.error) {
                  refreshPerformanceItems()
                } else {
                  toast({
                    description: t(
                      'something_went_wrong',
                      'Something went wrong. Please try again.',
                    ),
                    status: 'error',
                    isClosable: true,
                    duration: 5000,
                    position: 'top-right',
                    variant: 'outline',
                  })
                }
                onClose()
              }
              setIsDeleteDisabled(false)
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default DeleteUrlModal
